"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDecimalPriceToBn = exports.initializeAtaForMint = exports.getOrderSide = void 0;
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const spl_token_1 = require("@solana/spl-token");
const getOrderSide = (orderAccount) => {
    if (JSON.stringify(orderAccount.orderSide) === JSON.stringify({ buy: {} })) {
        return 'BuySide';
    }
    return 'SellSide';
};
exports.getOrderSide = getOrderSide;
function initializeAtaForMint({ mint, owner, connection, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const instructions = [];
        const ataPubkey = yield (0, token_1.associatedAddress)({ mint, owner });
        const ataPubkeyInfo = yield connection.getAccountInfo(ataPubkey);
        if (ataPubkeyInfo === null) {
            instructions.push(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, ataPubkey, owner, owner));
        }
        return { account: ataPubkey, instructions };
    });
}
exports.initializeAtaForMint = initializeAtaForMint;
const convertDecimalPriceToBn = (uiPrice, decimals) => {
    return new anchor_1.BN(uiPrice * Math.pow(10, decimals));
};
exports.convertDecimalPriceToBn = convertDecimalPriceToBn;
//# sourceMappingURL=gmHelper.js.map